export default __webpack_public_path__ + "static/media/giphy-1.d3d1f8bd.gif";